import React from 'react';
import { Alert, Box } from 'pounceV2';
import { Notification as NotificationType } from 'Generated/schema';
import NotificationActionsV3 from 'Components/Notifications/NotificationActionsV3';

export interface NotificationSnackbarProps {
  /** The notification title */
  title?: string;

  /** Whether the snackbar is visible */
  isOpen?: boolean;

  /** When the snackbar is discardable, this is the callback that gets fired on discard */
  onClose: () => void;

  /** The variant of notification */
  variant?: 'info' | 'warning' | 'error';

  /** The notification message */
  description?: React.ReactNode;

  /** Whether the snackbar should have a close button in order to remove itself */
  discardable?: boolean;

  /** The notification object */
  customProps: {
    notification: NotificationType;
  };
}

const NotificationSnackbarV3 = ({
  title,
  isOpen = true,
  onClose,
  description,
  variant = 'info',
  discardable,
  customProps: { notification },
}: NotificationSnackbarProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Box maxWidth={400}>
      <Alert
        variant={variant}
        variantBackgroundStyle="solid"
        discardable={discardable}
        onClose={onClose}
        title={title}
        description={description}
        actions={<NotificationActionsV3 notification={notification} />}
      />
    </Box>
  );
};

export default NotificationSnackbarV3;
